import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import checkStatus from '../utils/checkStatus';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from './JwtStore'

export default {
  getNavigation() {
    return fetch(api('navigation'),{
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => {
        Dispatcher.dispatch({
          actionType: ActionTypes.NAVIGATION_GET_COMPLETE,
          navigation: response
        });
      })
      .catch(dispatchHttpError);
  }
}
